import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  ButtonComponent,
  InputComponent,
  SelectComponent,
  TextareaComponent,
  ToastContainerComponent,
} from '@packages/ng-shared-ui';

import { HttpConfigInterceptor } from '../services/interceptor/http-loading-interceptor';
import { AuthenticationCheckService } from '../services/auth/authentication-check.service';
import { AuthGuardService } from '../services/auth/auth-guard.service';

@NgModule({
  declarations: [],
  exports: [
    // Angular common modules
    CommonModule,
    ReactiveFormsModule,
    FormsModule,

    // Atomic Design Components - ATOMS from @packages/ng-shared-ui
    ButtonComponent,
    InputComponent,
    SelectComponent,
    TextareaComponent,
    ToastContainerComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,

    // Standalone atomic components from @packages/ng-shared-ui
    ButtonComponent,
    InputComponent,
    SelectComponent,
    TextareaComponent,
    ToastContainerComponent,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        DatePipe,
        AuthenticationCheckService,
        AuthGuardService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpConfigInterceptor,
          multi: true,
        },
      ],
    };
  }
}
